import React from 'react';

const Arrow = ({ direction, color }) => {
    const isRight = direction === 'right';
    const arrowPath = "M21,8H11V5a1,1,0,0,0-1.707-.707l-7,7a1,1,0,0,0,0,1.414l7,7A1,1,0,0,0,11,19V16H21a1,1,0,0,0,1-1V9A1,1,0,0,0,21,8Z";

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{
                width: '70px',
                height: '70px',
                transform: isRight ? 'scaleX(-1)' : 'none',
            }}
        >
            <title>{isRight ? 'Right Arrow' : 'Left Arrow'}</title>
            <g>
                {/* Shadow */}
                <path
                    d={arrowPath}
                    style={{
                        fill: 'rgba(0, 0, 0, 0.5)',
                        transform: isRight ? 'translate(-2px, 2px)' : 'translate(2px, 2px)'
                    }}
                />
                {/* Main arrow */}
                <path
                    d={arrowPath}
                    style={{ fill: color }}
                />
            </g>
        </svg>
    );
};

export default Arrow;